import { isArray, isObject } from "./is.js";
import { hasWindow } from "./has.js";
function updateUrlSearchParam(params, name, value) {
  if (value === "" || value === null || value === void 0) {
    if (params.has(name)) {
      params.delete(name);
    }
    return params;
  }
  if (isArray(value)) {
    value.forEach((val, index) => {
      const arrayName = `${name}[${index}]`;
      updateUrlSearchParam(params, arrayName, val);
    });
    return params;
  }
  if (isObject(value)) {
    Object.entries(value).forEach(([key, val]) => {
      const objectName = `${name}[${key}]`;
      updateUrlSearchParam(params, objectName, val);
    });
    return params;
  }
  params.set(name, value);
  return params;
}
function objectToURLSearchParams(obj, defaultSearch = hasWindow() ? window.location.search : "") {
  return Object.entries(obj).reduce(
    (urlSearchParams, [name, value]) => updateUrlSearchParam(urlSearchParams, name, value),
    new URLSearchParams(defaultSearch)
  );
}
function updateHistory(mode, options, data = {}, title = "") {
  if (!window.history) {
    return;
  }
  const { path, search, hash } = {
    path: window.location.pathname,
    search: new URLSearchParams(window.location.search),
    hash: window.location.hash,
    ...options
  };
  let url = path;
  const mergedSearch = search instanceof URLSearchParams ? search : objectToURLSearchParams(search);
  if (mergedSearch.toString()) {
    url += `?${mergedSearch.toString()}`;
  }
  if (hash) {
    if (hash.startsWith("#")) {
      url += hash;
    } else {
      url += `#${hash}`;
    }
  }
  const method = `${mode}State`;
  window.history[method](data, title, url);
}
function push(options, data = {}, title = "") {
  updateHistory("push", options, data, title);
}
function replace(options, data = {}, title = "") {
  updateHistory("replace", options, data, title);
}
export {
  objectToURLSearchParams,
  push,
  replace
};
//# sourceMappingURL=history.js.map
